module.exports = __webpack_public_path__ + "img/H00020.65944711.png";